// extracted by mini-css-extract-plugin
module.exports = {"host":"CharityLink_host__3kEsX","icon":"CharityLink_icon__1MvBK","text":"CharityLink_text__REPKe"};